import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'src/root/store';

import { selectedOrganizationSel } from '@shared/duck/selectors/general.selectors';
import type { ParentUserOrganizationInfo } from '@user/types';

const moduleSel = (state: RootState) => state.parentGuardian;

export const childrenSel = createSelector(moduleSel, state => state.children);

/**
 * For the current *selected organization*, it returns wether the
 * parent has a SB connection but missing relationship for the selected child.
 * i.e. /myScout endpoint returns flag=false. See SBL-5981.
 *
 * We want to encourage users to migrate to relationships.
 */
export const hasMissingRelationshipSel = createSelector(
  selectedOrganizationSel,
  (organization: ParentUserOrganizationInfo) => {
    // We don't want to return true for leaders
    if (!organization.isParentGuardian) return false;

    const hasMissing = organization.missingRelationship;

    return hasMissing;
  },
);

/**
 * Returns the list of children for which there's a connection but missing relationships.
 * See SBL-5966
 */
export const missingRelationshipSel = createSelector(moduleSel, state =>
  state.children.filter(child => child.missingRelationship),
);

export const showMissingRelationshipsModalSel = createSelector(
  moduleSel,
  state => state.showMissingRelationshipsModal,
);
